var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGolf1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 60,
    viewBox: "0 0 120 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M98.1068 2.53348L101.053 6.21598L48.2843 49.734L47.2343 50.697L44.2433 54.4455C44.2433 54.4455 42.7223 55.956 42.4343 56.127C42.1463 56.298 40.0508 57.108 39.4358 57.1695C38.8208 57.231 36.8513 57.1935 36.6518 57.1695C36.4523 57.1455 32.5373 56.127 32.2118 55.9695C31.8863 55.812 29.6063 54.153 29.4638 53.982C29.3213 53.811 28.1768 51.423 28.1768 51.423L28.6058 47.058C28.6058 47.058 29.9378 45.246 30.2378 45.024C30.5378 44.802 33.7043 43.53 33.7043 43.53L35.9588 43.5495L37.7543 43.7325L40.0238 44.0655L41.3003 44.9355L42.9623 46.278L44.6378 48.591L47.2433 48.108L98.1068 2.53348Z",
    fill: "#FAFAFB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M79.3854 24.0856L77.0859 21.1846",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M80.7666 22.9456L78.3711 20.0446",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9233 21.7846L79.5713 18.9796L81.0848 17.6371L83.5943 20.7661L85.1453 19.3351L82.5353 16.2121L84.0623 14.9941L86.6708 18.0766L88.4303 16.6261L85.7828 13.4686L87.6428 11.8186L90.4268 15.1261L92.2568 13.4596L89.4548 10.2106L91.3808 8.50206L94.2773 11.8036L96.3563 10.0906L93.3848 6.72306L95.7563 4.61856L98.6438 8.20356",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.75 51.8956C28.75 51.8956 29.3395 50.8231 30.8815 50.7061C32.05 50.6176 37.6615 51.2941 40.3105 51.6271C41.326 51.7546 42.2695 52.2181 42.979 52.9546C43.36 53.3491 43.7965 53.8456 44.2405 54.4456",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7811 54.2067C37.864 53.5316 37.1146 52.8841 36.1074 52.7604C35.1001 52.6367 34.2164 53.0837 34.1335 53.7588C34.0506 54.4339 34.7999 55.0814 35.8072 55.205C36.8145 55.3287 37.6982 54.8817 37.7811 54.2067Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M37.99 52.5106L42.9595 53.1196",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9092 54.3451L43.6852 54.9316",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M37.373 55.9696L41.4965 56.2846",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7015 51.9841L29.1475 51.4246",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5915 53.5696L28.6045 53.0806",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4256 55.4851L30.9971 55.1866",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M100.228 5.18551L99.0344 3.69151C98.5304 3.06151 97.6019 2.98201 96.9989 3.51751L75.6059 22.4985L47.1344 47.7585C46.8734 47.9895 46.5644 48.1575 46.2284 48.2505C45.3224 48.4995 44.3549 48.1665 43.7954 47.4105L42.9269 46.236C42.5129 45.6765 42.0029 45.195 41.4194 44.8125L41.3414 44.7615C40.5554 44.247 39.6569 43.929 38.7224 43.833L34.8149 43.434C34.6589 43.4175 34.5014 43.4175 34.3454 43.434C33.1799 43.5615 28.4429 44.3805 28.0454 49.2495C27.5924 54.8055 32.7839 56.3595 34.7879 56.835C36.7904 57.3105 41.5019 58.1175 44.2439 54.4455C46.9859 50.7735 47.7449 50.1795 47.7449 50.1795L77.8994 25.311L100.035 7.05601C100.6 6.58951 100.686 5.75551 100.228 5.18401V5.18551Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M77.8984 25.3125L75.6064 22.4985",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7435 50.1794L46.7385 48.1094",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGolf1);
export default __webpack_public_path__ + "static/media/Golf 1.87adb79f7b262dc0d992703bf592e276.svg";
export { ForwardRef as ReactComponent };